export default "__VITE_ASSET__DKBdztfU__"